import InputPresentational from '../../../../components/Form/InputPresentational';
import DeleteAccountModal from '../../../../components/Modals/DeleteAccountModal';
import H3Styled from '../../../../components/Typography/H3Styled';
import { useAuth } from '../../../../contexts/Auth';
import { Profile } from '../../../../interfaces/profile';
import { isDelegato } from '../../../../libs/utils/auth';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { confirmUser, changeUserEmail } from '../../../../api/profile';
import { useForm } from 'react-hook-form';

const { REACT_APP_ASSISTENCE_EMAIL_ADDRESS } = process.env;

const ModificaUtenteImpostazioni = ({ infoUser }: { infoUser: Profile }) => {
  const [{ profile, token }] = useAuth();
  const queryClient = useQueryClient();

  const { mutate: confirm } = useMutation(confirmUser, {
    onSuccess: () => {
      toast.success('Account confermato con successo');
      queryClient.invalidateQueries({ queryKey: ['profile2'] });
    },
    onError: (error: any) => {
      toast.error(error.response.data.error.message);
    },
  });

  const { mutate: doChangeEmail, isLoading: isChangingEmail } = useMutation(
    changeUserEmail,
    {
      onSuccess: (data) => {
        toast.success(data.message || 'Email aggiornata. L\'utente riceverà un\'email di conferma.');
        queryClient.invalidateQueries({ queryKey: ['profile2'] });
        emailForm.reset();
      },
      onError: (error: any) => {
        toast.error(error?.response?.data?.error?.message || 'Errore durante il cambio email');
      },
    }
  );

  const emailForm = useForm<{ newEmail: string }>({ mode: 'onSubmit' });
  const { register, handleSubmit, formState: { errors } } = emailForm;

  const userId = infoUser.attributes.user.data?.id;

  return (
    <>
      {!isDelegato(profile) ? (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-end'>
          {!infoUser.attributes.user.data?.attributes.confirmed && (
            <>
              <div className='space-y-5'>
                <H3Styled>Conferma registrazione</H3Styled>
                <p className='text-sm text-gray-400'>
                  <br />
                  Clicca "Conferma registrazione" per confermare la
                  registrazione dell'utente.
                </p>
              </div>
              <div>
                <PrimaryButton
                  outline
                  onClick={() =>
                    confirm({ id: infoUser.attributes.user.data?.id!, token })
                  }
                >
                  Conferma registrazione
                </PrimaryButton>
              </div>
            </>
          )}

          <div className='space-y-5 mt-10 col-span-2'>
            <H3Styled>Cambio indirizzo email</H3Styled>
            <p className='text-sm text-gray-400'>
              Email attuale:{' '}
              <strong>{infoUser.attributes.user.data?.attributes.email}</strong>
              <br />
              Dopo il cambio l'utente riceverà un'email di conferma al nuovo indirizzo
              e dovrà cliccare il link per attivarlo.
            </p>
          </div>
          <form
            className='contents'
            onSubmit={handleSubmit((values) => {
              if (!userId) return;
              doChangeEmail({ userId, email: values.newEmail, token });
            })}
          >
            <InputPresentational
              id='newEmail'
              label='Nuovo indirizzo email'
              name='newEmail'
              type='email'
              register={register}
              required
            />
            <div>
              <PrimaryButton
                type='submit'
                outline
                isLoading={isChangingEmail}
                disabled={isChangingEmail}
              >
                Cambia indirizzo email
              </PrimaryButton>
            </div>
          </form>

          <div className='space-y-5 mt-10'>
            <H3Styled>Elimina account</H3Styled>
            <p className='text-sm text-gray-400'>
              Eliminando l'account del profilo utente selezionato tutti i suoi
              dati andranno persi.
              <br />
              <b>L'azione è irreversibile</b>.
            </p>
          </div>
          <div>
            <DeleteAccountModal infoUser={infoUser} />
          </div>
        </div>
      ) : (
        <p className='py-20 text-gray-400 '>
          Solo la segreteria nazionale ha accesso a queste impostazioni{' '}
        </p>
      )}
    </>
  );
};

export default ModificaUtenteImpostazioni;
